/**
 * @generated SignedSource<<7b8118b2db36d9da75d26e31888f318e>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "runningScheduleModel"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleShiftTablePanel_schedule",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "runningScheduleModel",
                    "variableName": "runningScheduleModel"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ScheduleShiftTable_schedule"
        }
    ],
    "type": "Schedule",
    "abstractKey": null
};
node.hash = "ff439988d50233d18f2b4b58660c041a";
export default node;
